module.exports = __webpack_public_path__ + "media/images/home-page/3-3-a6bb76495b041aae3808cc6330f43e0a.png";